declare global {
  interface Window {
    Razorpay: any;
  }
}

interface RazorpayOrder {
  order_id: string;
  amount: number;
  currency: string;
  key: string; // dynamic
}

interface RazorpayOptionsProps {
  order: RazorpayOrder;
  onSuccess: (data: any) => void;
  onFailure?: (error: any) => void;
  user?: {
    name?: string;
    email?: string;
    contact?: string;
  };
}

export const loadRazorpayScript = (): Promise<boolean> => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true); // already loaded
      return;
    }

    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;

    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.body.appendChild(script);
  });
};

export const openRazorpay = async ({
  order,
  onSuccess,
  onFailure,
  user,
}: RazorpayOptionsProps) => {
  const isLoaded = await loadRazorpayScript();
  if (!isLoaded) {
    alert("Razorpay SDK failed to load");
    return;
  }
  // ✅ FIX: fallback key
  const key = order.key 

  if (!key) {
    console.error("Razorpay key missing");
    return;
  }

  const options = {
    key,
    amount: order.amount,
    currency: order.currency,
    name: "Subscription",
    description: "Subscription Payment",
    order_id: order.order_id,

    handler: (response: any) => {
      // console.log(res/ponse,'razorpay response')
      onSuccess(response);
    },

    prefill: {
      name: user?.name || "",
      email: user?.email || "",
      contact: user?.contact || "",
    },

    theme: {
      color: "#f97316",
    },

    modal: {
      ondismiss: () => {
        onFailure?.("Payment cancelled");
      },
    },
  };

  const razorpay = new window.Razorpay(options);

  razorpay.on("payment.failed", (err: any) => {
    onFailure?.(err);
  });

  razorpay.open();
};